import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';

import { Button, Visible } from 'coreOld/components';
import { Icon, Title } from 'coreOld/elements';
import { ButtonType } from 'coreOld/enums';
import { useAppDispatch } from 'coreOld/hooks';
import { setSelectedRow } from 'coreOld/slices/tableSlice';

import {
  ButtonWrapper,
  Centered,
  iconStyle,
  RowWrapper,
  SubTitle,
  TitleWrapper,
  Wrapper,
} from './headerStyle';

interface IProps {
  isHeaderFixed?: boolean;
  text?: string;
  textUrl?: string;
  subText?: string | number | JSX.Element;
  antentTexts?: string[];
  actionBtnText?: string;
  action?;
  cancelBtnText?: string;
  cancelAction?;
  showInfoIcon?: boolean;
  item?;
}

const SubHeaderView = ({
  isHeaderFixed = true,
  text,
  textUrl,
  subText,
  antentTexts,
  actionBtnText,
  action,
  cancelBtnText = t('buttonLabelCancel'),
  cancelAction,
  showInfoIcon = false,
  item,
}: IProps) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const onShowInfoClick = () => dispatch(setSelectedRow(item));

  return (
    <Wrapper isHeaderFixed={isHeaderFixed}>
      {antentTexts && (
        <RowWrapper hasPaddingBottom>
          {antentTexts.map((text, index) => (
            <SubTitle key={index}>{text}</SubTitle>
          ))}
        </RowWrapper>
      )}

      <RowWrapper>
        <TitleWrapper>
          <Title hasUrl={Boolean(textUrl)} onClick={() => textUrl && navigate(textUrl)}>
            {text}
          </Title>

          <Title isSubtitle>{subText}</Title>
        </TitleWrapper>

        <ButtonWrapper>
          {showInfoIcon && item && (
            <Centered hasMarginRight={(cancelBtnText && cancelAction) || (actionBtnText && action)}>
              <Visible when={showInfoIcon}>
                <Icon name={Icon.INFO} onClick={onShowInfoClick} style={iconStyle} />
              </Visible>
            </Centered>
          )}

          {cancelBtnText && cancelAction && (
            <Button
              onClick={cancelAction}
              btnType={ButtonType.ACTION_INVERTED}
              fullWidth={false}
              hasMarginRight
            >
              {cancelBtnText}
            </Button>
          )}

          {actionBtnText && action && (
            <Button onClick={action} fullWidth={false}>
              {actionBtnText}
            </Button>
          )}
        </ButtonWrapper>
      </RowWrapper>
    </Wrapper>
  );
};

export default SubHeaderView;
